import { DataFaker } from '@cicero/data/utils'
import { ILineGraphData } from '../LineGraph'
import { IPieChartData } from '../PieChart'
import { IStatsListItem } from '../StatList'
import { ITreeMapData } from '../TreeMap'

export const generatePieChartData = (countSeed: number): IPieChartData[] => {
  return DataFaker.genFactory((seed) => ({
    label: DataFaker.gen(DataFaker.DRINKS, seed),
    value: Math.max(DataFaker.gen(DataFaker.DATE_HOURS, seed), 1),
  }), Math.max(DataFaker.gen(DataFaker.DATE_MONTHS, countSeed) || 3))
}

export const generateLineGraphData = (countSeed: number): ILineGraphData[] => {
  return DataFaker.genFactory((seed) => ({
    label: DataFaker.gen(DataFaker.DRINKS, seed),
    value: DataFaker.genFactory((s2) => ([
      s2,
      DataFaker.gen(DataFaker.DATE_MINUTES, s2 * seed * countSeed),
    ]), 30),
  }), 4)
}

export const generateTreeMapData = (countSeed: number): ITreeMapData => {
  return {
    label: 'Root',
    children: DataFaker.genFactory(seed => ({
      label: DataFaker.gen(DataFaker.DRINKS, seed),
      value: DataFaker.gen(DataFaker.DATE_MONTHS, seed + countSeed),
    }), DataFaker.gen([5,6,7,8,9,10], countSeed)),
  }
}

export const stats: IStatsListItem[] = [
  { title: 'Days Left in Sprint', value: 6 },
  { title: 'Points Left in Sprint', value: 20 },
  { title: 'Unestimated Stories', value: 50 },
  { title: '6 Week Velocity', value: '50/w' },
  { title: 'Sprint Participants', value: 1 },
  { title: 'Epics', value: 6 },
  { title: 'Stories', value: 160 },
  { title: 'Sprints', value: 4 },
]

export const demoStats: IStatsListItem[] = [
  { title: 'Beans', value: 6 },
  { title: 'Cats', value: 156 },
  { title: 'Number of Items', value: 22 },
  { title: 'Number of Dogs', value: 542 },
  { title: 'Number of Machines', value: 1025 },
  { title: 'Barrys', value: 90012030213 },
]
